//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { success } from '@/utils/notify.js'
import {
  insertOrUpdateKsCjfh,
  queryKsCjfh,
  queryKsCjxList,
} from '@/https/otherApplication'
import { MaxLength } from '@/utils/validatorClass'
import {
  MultiSelectPopup,
  Span,
  Textarea,
} from '@/constant/componentConfig'
import CForm from '@/components/CForm'

export default {
  components: { CForm },

  props: {
    model: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return {
      studyInfo: {},
      markList: [],
    }
  },

  computed: {
    renderData () {
      return [
        new Span({
          label: '姓名',
          value: 'xm',
          name: 'xm',
        }),
        new Span({
          value: 'ksh',
          name: 'xm',
          label: '考生号',
        }),
        new Span({
          value: 'zjhm',
          name: 'zjhm',
          label: '证件号码',
        }),
        new MultiSelectPopup({
          label: '成绩项目',
          value: 'cjxdm',
          name: 'cjxdm',
          valueName: 'value',
          labelFormat: '{key}',
          required: true,
          list: this.markList,
        }),
        new Textarea({
          value: 'sqly',
          required: true,
          label: '申请理由',
          rules: [new MaxLength('申请理由', 200)],
        }),
      ]
    },
  },

  watch: {},

  created () {
    this.queryMarks()
    this.queryBaseInfo()
  },

  methods: {
    async queryBaseInfo () {
      const { data } = await queryKsCjfh({
        pcdm: this.$route.query.pcdm,
        wid: this.$route.query.wid,
      })

      this.studyInfo = {
        ...data || {},
        cjxdm: data.cjxdm ? data.cjxdm.split(',') : [],
      }
    },

    async queryMarks () {
      const { data } = await queryKsCjxList({
        pcdm: this.$route.query.pcdm,
        wid: this.$route.query.wid,
      })

      this.markList = data || []
    },

    goBack () {
      this.$router.go(-1)
    },

    async save () {
      if (!(await this.$refs.form.validate())) {
        return
      }

      const { code } = await insertOrUpdateKsCjfh({
        ...this.studyInfo,
        cjxdm: this.studyInfo.cjxdm.join(','),
      })

      if (+code === 0) {
        success('保存成功')
        this.$router.go(-1)
      }
    },
  },
}
